import { createReducer } from '@reduxjs/toolkit';

import getPriorityCoOrders from '../../../thunks/coilovers/orders/getPriorityCoOrders';

const initialState = {
  loading: false,
  error: null,
  data: [],
  lastPage: undefined,
  currentPage: 1,
  total: 0
};

const getPriorityCoOrdersReducer = createReducer(initialState, {
  [getPriorityCoOrders.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getPriorityCoOrders.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total
    }
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getPriorityCoOrders.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getPriorityCoOrdersReducer;
